module.exports = "img/flags/BL.eb77708.png";